import styled from 'styled-components';
import CountUp from 'react-countup';
import Container from 'components/Container';
import Button from 'components/Button';
import Tooltip from 'components/Tooltip';
import Select from 'components/Inputs/Select';
import { sizes } from 'style';
import { th } from 'style/theme';

export const PricingContainer = styled(Container)`
  color: ${({ theme }) => theme.colors.white};
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media ${sizes.largeDesktop} {
    min-height: 100vh;
  }
`;

export const Subtitle = styled.p`
  font-size: 16px;

  @media ${sizes.tabletPortrait} {
    font-size: 18px;
  }
`;

export const Content = styled.div`
  padding-top: ${th('space.6')}px;
  display: flex;
  flex-direction: column;

  @media ${sizes.tabletPortrait} {
    flex: 1;
    flex-direction: row;
  }

  @media ${sizes.extraLargeDesktop} {
    max-width: 100%;
  }
`;

export const Options = styled.div`
  @media ${sizes.tabletPortrait} {
    flex: 1;
    padding-right: ${th('space.6')}px;
  }

  @media ${sizes.extraLargeDesktop} {
    flex: 2;
    padding-right: 0;
    padding-top: ${th('space.8')}px;
  }
`;

export const TotalContainer = styled.div`
  display: flex;
  flex-direction: column-reverse;

  @media ${sizes.tabletPortrait} {
    flex: 1;
    justify-content: space-between;
  }

  @media ${sizes.extraLargeDesktop} {
    flex: 3;
    flex-direction: row;
    justify-content: initial;
  }
`;

export const Total = styled.div`
  padding-top: ${th('space.10')}px;

  @media ${sizes.tabletPortrait} {
    padding-top: 0;
  }

  @media ${sizes.extraLargeDesktop} {
    width: 230px;
    padding-top: 60px;
  }
`;

export const Illustration = styled.div`
  align-self: flex-end;

  @media ${sizes.extraLargeDesktop} {
    flex: 2;
    padding-right: 40px;
  }

  > img {
    width: 100%;
    max-width: 610px;
    height: auto;
    margin-bottom: -7px;
  }
`;

export const LengthOfCoverage = styled.div`
  margin-top: ${th('space.10')}px;
  margin-bottom: ${th('space.5')}px;
`;

export const SmallText = styled.div`
  font-size: 14px;
  margin-top: ${th('space.4')}px;

  @media ${sizes.extraLargeDesktop} {
    margin-top: ${th('space.10')}px;
  }
`;

export const TotalInDollars = styled(CountUp)`
  display: block;
  font-size: 60px;
  font-weight: bold;

  ::before {
    content: '$';
    font-size: 35px;
    vertical-align: top;
  }
`;

export const TotalTime = styled.div`
  font-size: 18px;
`;

export const AgeRangeDropdown = styled(Select)`
  width: 100%;
  margin-bottom: ${th('space.10')}px;

  > label {
    margin-bottom: 10px;
  }

  @media ${sizes.tabletPortrait} {
    width: 230px;
  }
`;

export const ChildrenText = styled.div`
  padding-top: ${th('space.4')}px;

  > :not(:first-child) {
    font-size: 14px;
  }
`;

export const SignupButton = styled(Button)`
  margin-top: ${th('space.4')}px;

  @media ${sizes.largeDesktop} {
    margin-top: ${th('space.10')}px;
  }
`;

export const DateSelection = styled.div`
  padding-top: ${th('space.6')}px;
  display: flex;
  flex-direction: column;

  @media ${sizes.tabletPortrait} {
    width: 230px;
  }

  @media ${sizes.largeDesktop} {
    width: 440px;
    flex-direction: row;
  }
`;

export const DatePickerContainer = styled.div`
  flex: 1;

  > :first-child {
    display: block;
    padding-bottom: ${th('space.1')}px;
  }

  &:first-child {
    padding-bottom: ${th('space.5')}px;
  }

  @media ${sizes.largeDesktop} {
    &:first-child {
      padding-right: ${th('space.5')}px;
    }
  }
`;

export const StyledTooltip = styled(Tooltip)`
  margin-left: ${th('space.2')}px;
`;

export const SafetyNest = styled.div`
  > a,
  > a:hover {
    color: ${th('colors.white')};
  }
`;
